@if (!franchise) {
  <app-spinner></app-spinner>
} @else {
  <div class="layout">
    <div class="main-content">
      <header>
        <nav>
          <ul class="nav">
            <li [class.active]="section === 'about'"><a routerLink="/about">
              About TYT
              <img src="/assets/subnav_pointer.svg" class="sub-nav-pointer" />
            </a></li>
            <li [class.active]="section === 'talent'"><a routerLink="/about/talent">
              People
              <img src="/assets/subnav_pointer.svg" class="sub-nav-pointer" />
            </a></li>
            <li [class.active]="section === 'announcement'"><a routerLink="/about/announcement">
              Announcements
              <img src="/assets/subnav_pointer.svg" class="sub-nav-pointer" />
            </a></li>
            <li [class.active]="section === 'press'"><a routerLink="/about/press">
              Press
              <img src="/assets/subnav_pointer.svg" class="sub-nav-pointer" />
            </a></li>
          </ul>
        </nav>
      </header>

      @if (section === 'loading') {
        <div class="franchise-container">
          <app-spinner></app-spinner>
        </div>
      }

      @if (section === 'about') {
        <div class="franchise-container">
          <div class="franchise-description cms-content" [innerHTML]="franchise.description | markdownToHtml | trustHtml">
          </div>
          <div class="socials">
            <h2>Follow us!</h2>
            <div class="social-links">
              @if (franchise.twitter_handle) {
                <a target="_blank"
                  href="https://twitter.com/{{franchise.twitter_handle}}">
                  <img src="/assets/icons/twitter.svg" alt="twitter" class="icon">&#64;{{franchise.twitter_handle}}
                </a>
              }
              @if (franchise.youtube_url) {
                <a target="_blank" href="https://{{franchise.youtube_url}}">
                  <img src="/assets/icons/youtube.svg" alt="youtube" class="icon">{{franchise.youtube_url}}
                </a>
              }
              @if (franchise.facebook_url) {
                <a target="_blank" href="https://{{franchise.facebook_url}}">
                  <img src="/assets/icons/facebook.svg" alt="facebook" class="icon">{{franchise.facebook_url}}
                </a>
              }
            </div>
          </div>
        </div>
      }

      @if (section === 'talent') {
        <div class="franchise-container">
          @if (person) {
            <h1 class="host-name">{{ person.name }}</h1>
            @if (person.thumbnail_square || person.thumbnail_portrait1 || person.thumbnail_landscape1) {
              <div class="host-image"
                [responsiveBackgroundImage]="person.thumbnail_square ?? person.thumbnail_portrait1 ?? person.thumbnail_landscape1"
              ></div>
            }
            <div class="host-bio cms-content" [innerHTML]="person.bio | markdownToHtml | trustHtml"></div>
            <div class="logos">
              @for (show of person.shows; track show) {
                <a routerLink="/shows/{{show.slug || show.id}}">
                  <div class="show-logo" [responsiveBackgroundImage]="show.logo_square"></div>
                </a>
              }
              @for (franchise of person.franchises; track franchise) {
                <a [routerLink]="urlForFranchise(franchise)">
                  <div class="show-logo" [responsiveBackgroundImage]="franchise.square_logo || franchise.image"></div>
                </a>
              }
            </div>
            @if (person.twitter_handle || person.facebook_url || person.instagram_handle) {
              <div class="socials"
                >
                <h2>Follow {{ person.name }}</h2>
                <div class="social-links">
                  @if (person.twitter_handle) {
                    <a target="_blank"
                      href="https://twitter.com/{{person.twitter_handle}}">
                      <img src="/assets/icons/twitter.svg" alt="twitter" class="icon">&#64;{{person.twitter_handle}}
                    </a>
                  }
                  @if (person.facebook_url) {
                    <a target="_blank" href="https://{{person.facebook_url}}">
                      <img src="/assets/icons/facebook.svg" alt="facebook" class="icon">{{person.facebook_url}}
                    </a>
                  }
                  @if (person.instagram_handle) {
                    <a target="_blank"
                      href="https://www.instagram.com/{{person.instagram_handle}}">
                      <img src="/assets/icons/iconmonstr-instagram-11.svg" alt="instagram" class="icon">&#64;{{person.instagram_handle}}
                    </a>
                  }
                </div>
              </div>
            }
          }
          @if (!person) {
            <div class="talents">
              @for (host of franchise.hosts; track host) {
                <div class="host-container">
                  <a class="talent" [routerLink]="(host.username && shouldShowTalentUser) ? '/@'+host.username : '/about/talent/'+host.id">
                    <div class="host-portrait" [responsiveBackgroundImage]="host.thumbnail_square || host.thumbnail_portrait1 || host.thumbnail_landscape1"></div>
                    <p class="host-name">{{ host.name }}</p>
                  </a>
                </div>
              }
            </div>
          }
        </div>
        @if (hostProductionUpdated) {
          @if (hostProductionType === 'episodes') {
            <div class="host-production">
              <h2>Recent Episodes</h2>
              @for (episode of hostProductions; track episode) {
                <tyt-production-view [production]="episode" mode="episodes">
                </tyt-production-view>
              }
            </div>
          }
          @if (hostProductionType === 'podcasts') {
            <div class="host-production">
              <h2>Recent Podcasts</h2>
              @for (podcast of hostProductions; track podcast) {
                <tyt-production-view [production]="podcast" mode="podcasts">
                </tyt-production-view>
              }
            </div>
          }
        }
        @if (talentArticles) {
          <div>
            <h2>Recent Articles</h2>
            @for (article of talentArticles; track article; let i = $index) {
              <div>
                <tyt-article-list-item [article]="article" [showImage]="false" [showFranchise]="false">
                </tyt-article-list-item>
              </div>
            }
          </div>
        }
      }

      @if (section === 'announcement') {
        <div>
          @if (currentAnnouncement) {
            <div class="date"><span>{{currentAnnouncement.date | asDate | date: 'MMMM d'}}</span></div>
            <div class="announcement">
              @if (currentAnnouncement.image) {
                <div class="announcement-image"
                [responsiveBackgroundImage]="currentAnnouncement.image"></div>
              }
              <div class="announcement-info">
                <h1 class="announcement-title">{{currentAnnouncement.title}}</h1>
                <div class="announcement-author-date">
                  @if (currentAnnouncement.members_only) {
                    <tyt-plus-tag class="tyt-plus"></tyt-plus-tag>
                  }
                  @if (currentAnnouncement.author) {
                    <span class="author">By <a
                    [routerLink]=" (currentAnnouncement.author.username && shouldShowTalentUser) ? '@/'+currentAnnouncement.author.username : '/about/talent/'+currentAnnouncement.author.id">{{ currentAnnouncement.author.name}}</a></span>
                  }
                </div>
                <p class="announcement-text cms-content" [innerHTML]="currentAnnouncement.text | markdownToHtml | trustHtml"></p>
              </div>
              @if (currentAnnouncement) {
                <tyt-comments
                  identifier="announcement_{{currentAnnouncement.id}}"
                  [url]="urlForAnnouncement(currentAnnouncement)"
                  >
                </tyt-comments>
              }
            </div>
          } @else {
            @for (announcement of announcements; track announcement) {
              <div class="announcement">
                <div class="announcement-info">
                  <h1 class="announcement-title">
                    <a routerLink="/about/announcement/{{announcement.id}}">{{announcement.title}}</a>
                  </h1>
                  <div class="announcement-author-date">
                    @if (announcement.members_only) {
                      <tyt-plus-tag class="tyt-plus"></tyt-plus-tag>
                    }
                    <span class="author">
                      @if (announcement.author) {
                        By <a [routerLink]="(announcement.author.username && shouldShowTalentUser)
                                        ? '@/'+announcement.author.username : '/about/talent/'+announcement.author.id">
                          {{ announcement.author.name }}
                        </a> |
                      }
                      {{announcement.date | asDate | date: 'fullDate'}} |
                      <tyt-comments-count identifier="announcement_{{announcement.id}}"></tyt-comments-count>
                    </span>
                  </div>
                </div>
              </div>
          }
          <tyt-pager [total]="total" [page]="page" [size]="announcementsPageSize" (changePage)="goToPage($event)"></tyt-pager>
        }
        </div>
      }

      @if (section === 'press') {
        <div>
          @for (press of pressArticles; track press; let i = $index) {
            <div class="date">
              @if (i !== 0) {
                <span>{{press.date | asDate | date: 'MMMM d'}}</span>
              }
            </div>
            <div class="press">
              <a class="logo-link" target="_blank" href="{{press.url}}">
                <picture responsive class="press-image" [src]="press.image"></picture>
              </a>
              <a target="_blank" href="{{press.url}}">
                <h1 class="press-title">{{press.title}}</h1>
              </a>
              @if (press.author) {
                <span class="author"> By <a [routerLink]="(press.author.username && shouldShowTalentUser) ? '@/'+press.author.username : '/about/talent/'+press.author.id" >{{
                press.author.name }}</a> | {{press.date | date: 'fullDate'}}</span>
              }
              <div class="social-buttons">
                <tyt-social-buttons [url]="press.url"></tyt-social-buttons>
              </div>
              <p class="press-summary cms-content" [innerHTML]="press.summary | markdownToHtml | trustHtml"></p>
              <a target="_blank" href="{{press.url}}">
                <tyt-form-submit-button>Read More</tyt-form-submit-button>
              </a>
            </div>
          }
          <tyt-pager [total]="total" [page]="page" [size]="size" (changePage)="goToPage($event)"></tyt-pager>
        </div>
      }
    </div>
  </div>
}

<tyt-awards></tyt-awards>
